<template>
  <div>
    <div class="article-header-banner">
      <h1 class="header-title">{{ articles.maintitle }}</h1>
      <slot v-if="articles.maindescription" name="description"></slot>
    </div>
    <div
      v-for="(article, articleIndex) in loadedArticles"
      :key="articleIndex"
      class="article-blocks"
    >
      <div class="article-col1">
        <div class="hide-in-desktop">
          <img
            v-if="article.image"
            :src="article.image.Src"
            :alt="article.image.Alt"
            class="article-preview-image"
            @click="redirectionToArticle(article)"
          />
        </div>
        <h2 class="article-title" @click="redirectionToArticle(article)">{{ article.title }}</h2>
        <slot :name="article.article_id"></slot>
        <a
          v-if="articles.filterdata"
          :href="article.url"
          class="article-read-more-button hide-in-desktop"
          >{{ articles.filterdata.read_more }}</a
        >
      </div>
      <div class="article-col2 hide-in-mobile">
        <div>
          <img
            v-if="article.image"
            :src="article.image.Src"
            :alt="article.image.Alt"
            class="article-preview-image"
            @click="redirectionToArticle(article)"
          />
        </div>
        <a
          v-if="articles.filterdata"
          :href="article.url"
          class="article-read-more-button"
          @click="taggingToArticleReadmore(article, articles.filterdata.read_more)"
          >{{ articles.filterdata.read_more }}</a
        >
      </div>
    </div>
    <div v-if="remainingArticles > 0" class="article-load-more-block">
      <button
        class="load-more-button ripple-animation ripple-animation--black"
        @click="loadMoreArticle"
      >
        {{ articles.filterdata.more_articles }} ({{ remainingArticles }})
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'articles-block',
  props: {
    articles: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      articlesList: [],
      loadedArticles: [],
      initialItemToShow: 6,
      lastIndex: 0,
      remainingArticles: 0,
    };
  },
  mounted() {
    this.articlesList = this.articles.topics;
    this.loadMoreArticle();
  },
  methods: {
    loadMoreArticle() {
      if (this.lastIndex < this.articlesList.length) {
        let bufferArray = [];
        bufferArray = this.articlesList.slice(
          this.lastIndex,
          this.lastIndex + this.initialItemToShow,
        );
        this.loadedArticles = this.loadedArticles.concat(bufferArray);
        this.lastIndex = this.lastIndex + this.initialItemToShow;
        this.remainingArticles = this.articlesList.length - this.loadedArticles.length;
      }
    },
    redirectionToArticle(article) {
        dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'content page',
        eventAction: `select::${article.title.toLowerCase().trim()}`,
        eventLabel: `${[article.title.toLowerCase().trim()]}::${[article.url.toLowerCase().trim()]}`,
        event_name: 'body_button_click',
        module_name: `${article.title.toLowerCase().trim()}`,
        cta_name: `${article.title.toLowerCase().trim()}`,
        link_url: `${article.url.toLowerCase().trim()}`,
      });
      window.location.href = article.url;
    },
    taggingToArticleReadmore(article) {
        dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'content page',
        eventAction: `select::${article.title.toLowerCase().trim()}`,
        eventLabel: `${[article.title.toLowerCase().trim()]}::${[article.url.toLowerCase().trim()]}`,
        event_name: 'body_button_click',
        module_name: `${article.title.toLowerCase().trim()}`,
        cta_name: `${article.title.toLowerCase().trim()}`,
        link_url: `${article.url.toLowerCase().trim()}`,
      });
    },
  },
};
</script>
